import React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom'
import { getAllGroups, getAllProjectsByEnterpriseId, getAllResponsesFormProject } from '../redux/VRL/thunks';
import { setAdminEnterpiseid } from '../redux/auth/authSlice'

const LayoutAdminRoute = () => {
    const { idEnterprise = '0' } = useParams();
    const dispatch = useDispatch()

    useEffect(() => {
        const getDataFormPath = async () => {
            const proyects = await dispatch(getAllProjectsByEnterpriseId(idEnterprise))
            dispatch(setAdminEnterpiseid(idEnterprise))
            if (proyects.length > 0) {
                dispatch(getAllResponsesFormProject(proyects[0]._id))
                dispatch(getAllGroups(proyects[0]._id))
            }
        }
        getDataFormPath()
    }, [dispatch, idEnterprise])

    return (
        <Outlet />
    )
}

export default LayoutAdminRoute
